<template>
  <div class="wrapper">
   <item-detail :detail="detail"></item-detail>
  </div>
</template>
<script>
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
import itemDetail from "@/components/common/itemDetail.vue";
export default {
  data() {
    return {
      detail: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    ...mapActions(["firstTitle", "secondTitle"]),
    getDetail() {
      if (this.$route.query.section == "1") {
        this.secondTitle("专题活动");
      } else if (this.$route.query.section == "2") {
        this.secondTitle("党建动态");
      }else if (this.$route.query.section == "3") {
        this.secondTitle("党风廉政");
      }else if (this.$route.query.section == "4") {
        this.secondTitle("群团建设");
      }   else {
        this.secondTitle("图片新闻");
      }
      userApi.getpartyDeatil({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
      });
    }
  },
  watch: {
    $route() {
      this.getDetail();
    }
  },
  components: {
    itemDetail
  }
};
</script>

<style lang="less" scoped>

@import "./../../common/minix.less";
.wrapper {
  padding: 20 / @rem;
  box-sizing: border-box;
  background: #f2f2f2;
}
</style>




// WEBPACK FOOTER //
// src/components/ComParty/detail.vue